import React from 'react';

import {BaseTypedValueType, TypedValue} from 'notebook/tables/TableConstants';
import tableMultiKeyDownHandler from 'notebook/tables/tableMultiKeyDownHandler';
import {getTypedValueFromPartySummaries} from 'notebook/tables/typed-values/DataTypes';
import {PartyInfo} from 'notebook/tables/typed-values/TypedValueTypes';
import {EntityWithTextAndSuspended} from 'ui-library/entity-input/EntityInputConstants';
import {EntityInputWithSearch, UserSearchType} from 'ui-library/entity-input/EntityInputWithSearch';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';
import {ElementKeyboardEvent, Optional} from 'util/Types';

interface SampleRolesPartiesSearchInputProps {
  typedValue: TypedValue | null;
  handleUpdateTypedValue(typedValue: TypedValue): void;
  onEscape: () => void;
  onSetCellData: (value: Optional<string>, cellData: {typedValue: TypedValue | null}) => void;
  onTabKey: (e: ElementKeyboardEvent) => void;
  allowBenchlingApps?: boolean;
}

export default function SampleRolesPartiesSearchInput(
  props: SampleRolesPartiesSearchInputProps
): JSX.Element {
  const partySummaries: Array<PartyInfo> =
    props.typedValue?.type === BaseTypedValueType.PARTIES ? props.typedValue.partySummaries : [];

  const handleSetValue = (typedValue: TypedValue | null): void => {
    props.onSetCellData('', {typedValue});
  };

  const handleKeyDown = (e: ElementKeyboardEvent): void => {
    tableMultiKeyDownHandler({
      event: e,
      value: props.typedValue,
      onSetValue: handleSetValue,
      onEscape: props.onEscape,
      onTabKey: props.onTabKey,
    });
  };

  return (
    <EntityInputWithSearch
      placeholder="Search for user or team"
      enableNewEntityInput={true}
      allowEmails={true}
      allowTeams={true}
      allowOrganizations={false}
      allowBenchlingApps={props.allowBenchlingApps}
      shouldAllowMultiple={true}
      userSearchType={UserSearchType.All}
      onChange={(entityArray: Array<EntityWithTextAndSuspended>) => {
        props.handleUpdateTypedValue(
          // @ts-expect-error - entityArray is guaranteed to not have any organizations
          getTypedValueFromPartySummaries(entityArray)
        );
      }}
      value={partySummaries}
      size={TagsInputSize.SMALL}
      emptyText="No results found"
      onKeyDown={handleKeyDown}
    />
  );
}
